import { motion } from 'framer-motion';

export default function HeroSection({
  tag,
  title,
  subtitle,
  image,
  children,
  heroAlign = 'center',
  sectionClassName = '',
}) {
  const isLeft = heroAlign === 'left';

  return (
    <section
      className={`relative flex min-h-[480px] w-full items-center justify-center overflow-hidden h-[78svh] md:min-h-[620px] md:h-[82vh] ${sectionClassName}`}
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.7) 50%, rgba(0,0,0,0.4) 100%)',
        }}
      />

      <div
        className={`relative z-10 mx-auto max-w-5xl px-5 pt-24 pb-10 sm:px-6 md:pt-32 md:pb-14 text-white ${
          isLeft ? 'text-left' : 'text-center'
        }`}
      >
        {tag && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="mb-5 inline-block rounded-full border border-amber-400/30 bg-amber-400/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-amber-400">
              {tag}
            </span>
          </motion.div>
        )}

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mb-5 text-4xl font-bold leading-[0.95] tracking-tight text-white drop-shadow-[0_6px_24px_rgba(0,0,0,0.65)] sm:text-5xl md:mb-6 md:text-7xl"
          dangerouslySetInnerHTML={{ __html: title }}
        />

        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className={`mb-7 max-w-2xl text-base leading-relaxed text-white/90 drop-shadow-[0_4px_18px_rgba(0,0,0,0.6)] sm:text-lg md:mb-8 md:text-xl ${
              isLeft ? '' : 'mx-auto'
            }`}
          >
            {subtitle}
          </motion.p>
        )}

        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.35 }}
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
}
